import React, { useState, useEffect, useMemo } from "react";
import "./News&EventsAddEdit.css";
import DashNav from "../../Components/DashNav/DashNav";
import InputField from "../../Components/InputField/InputField";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import Gbtn from "../../Components/buttons/Gbtn";
import NewsPaper from "../../Components/SVGS/NewsPaper";
import { FcDocument } from "react-icons/fc";
import Modal from "react-modal";
import LoadingSpinner from "../../Components/LoadingSpinner/LoadingSpinner";
import noImage from "../../Assests/avatar1.png";
import { deleteNE, getAllCatageory, postNE } from "../../api";
import validator from "validator";
import { RxCross2 } from "react-icons/rx";
import RichTextarea from "../../Components/RichTextArea";
import { Document, Page, pdfjs } from "react-pdf";
import DocViewerComp from "../../Components/DocViewerComp/DocViewerComp";
import { componentsToColor } from "pdf-lib";

function NEAddEdit({ isEdit, isDelete }) {
  const icon = () => {
    return <NewsPaper size="26" height="30" fill="#DF2F35" />;
  };

  const location = useLocation();
  const newsEventObj =
    location.state && location.state ? location.state.NEToEdit : "";
  const page = location.state && location.state ? location.state.page : null;


  let baseUrl = process.env.REACT_APP_BASE_URL;
  const [isLoading, setIsLoading] = useState(false);
  const [isErr, setisErr] = useState(false);
  const [errMsg, seterrMsg] = useState("");
  const [profileImage, setProfileImage] = useState("");
  const [images, setImages] = useState(newsEventObj ? newsEventObj.news_event_images : []);
  const [deletedimages, setDeletedImages] = useState([]);
  const [editImage, setEditImage] = useState("");
  const [imageErr, setImageErr] = useState(false);
  let [uploadedDoc, setUploadedDoc] = useState("");
  let [thumbnailType, setthumbnailType] = useState(
    isDelete || isEdit ? true : false
  );
  const [selectedCat, setSelectedCat] = useState("");
  const [catErr, setCatErr] = useState(false);
  const [titleErr, setTitleErr] = useState(false);
  const [authErr, setauthErr] = useState(false);
  const [shortDescriptionErr, setshortDescriptionErr] = useState(false);
  const [detDescriptionErr, setdetDescriptionErr] = useState(false);
  const [yLinkErr, setyLinkErr] = useState(false);
  const [isValidUrl, setIsValidUrl] = useState(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [docErr, setdocErr] = useState(false);
  const [imageImputErr, setimageImputErr] = useState(false);
  const [catOpt, setcatOpt] = useState([]);
  const [authOptions, setAuthOptions] = useState([]);
  const [newsEvents, setnewsEvents] = useState({
    id: newsEventObj ? newsEventObj.id : 0,
    title: newsEventObj ? newsEventObj.title : "",
    short_description: newsEventObj ? newsEventObj.short_description : "",
    detailed_description: newsEventObj ? newsEventObj.detailed_description : "",
    image_path: newsEventObj ? newsEventObj.image_path : "",
    document_path: newsEventObj ? newsEventObj.document_path : "",
    youtube_link: newsEventObj ? newsEventObj.youtube_link : "",
    category_type: newsEventObj ? newsEventObj.category_type : null,
  });

  const navigate = useNavigate();

  const discardOnclick = () => {
    navigate("/dashboard/news&Events", {
      state: { page: page },
    });
  };

  useEffect(() => {
    getAuthors();
    setEditImage(newsEventObj ? newsEventObj.image_path : "");
    setEditDoc(
      newsEventObj
        ? newsEventObj.document_path == "null"
          ? ""
          : newsEventObj.document_path
        : ""
    );
  }, []);

  useEffect(() => {
    Modal.setAppElement("#root");
  }, []);

  const getAuthors = () => {
    getAllCatageory(100, 1).then(({ data }) => {
      if (data.error_code === 0) setAuthOptions(data.result);
    });
  };

  useEffect(() => {
    setOptions();
  }, [authOptions]);

  const setOptions = () => {
    let arr = [];
    for (let index = 0; index < authOptions.length; index++) {
      const element = authOptions[index];
      let obj = { value: element.id, label: element.name };
      arr.push(obj);
      if (element.id === newsEventObj.category_type) setSelectedCat(obj);
    }
    setcatOpt(arr);
  };

  const onSelectImage = (imgs) => {
    const files = Array.from(imgs);
    files.forEach(img => {
      if (
        img.type.includes("png") ||
        img.type.includes("jpg") ||
        img.type.includes("jpeg")
      ) {
        setImages((prev) => [...prev, img]);
        setImageErr(false);
        setEditImage("");
      } else {
        alert("Invalid File!");
      }
    })
  };

  const [editDoc, setEditDoc] = useState("");
  const onSelectDoc = (docc) => {
    if (!docc.type.includes("pdf")) setthumbnailType((thumbnailType = true));
    if (
      docc.type.includes("pdf") ||
      docc.type.includes("ppt") ||
      docc.type.includes("doc") ||
      docc.type.includes("docx")
    ) {
      setUploadedDoc((uploadedDoc = docc));
      setEditDoc("");

      if (docc.type.includes("pdf")) getPdfImg();
    } else alert("Invalid field");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setnewsEvents({ ...newsEvents, [name]: value });
  };

  const setCatType = (e) => {
    newsEvents.category_type = e.value;
    setSelectedCat(e);
  };

  const addOnclick = () => {
    if (
      newsEvents.youtube_link &&
      newsEvents.youtube_link !== "" &&
      !validate(newsEvents.youtube_link)
    ) {
      setdetDescriptionErr(false);
      setshortDescriptionErr(false);
      setCatErr(false);
      setTitleErr(false);
      setIsValidUrl(false);
    }

    else {
      setdocErr(false);
      setyLinkErr(false);
      setdetDescriptionErr(false);
      setshortDescriptionErr(false);
      setIsValidUrl(true);
      setCatErr(false);
      setTitleErr(false);
      setimageImputErr(false);
      setIsLoading(true);
      let data = new FormData();
      data.append("id", newsEvents.id);
      data.append("title", newsEvents.title);
      data.append("short_description", newsEvents.short_description);
      data.append("detailed_description", newsEvents.detailed_description);
      data.append("youtube_link", newsEvents.youtube_link);
      if (newsEvents.category_type !== null)
        data.append("category_type", newsEvents.category_type);
      if (typeof uploadedDoc == "string") data.append("document_path", editDoc);
      else data.append("document", uploadedDoc, uploadedDoc.name);
      images.forEach((img, index) => {
        data.append(`news_event_images[${index}].id`, img?.id ? img.id : 0);
        data.append(`news_event_images[${index}].news_event_id`, newsEvents?.id ? newsEvents.id : 0);
        if (img.image_path) data.append(`news_event_images[${index}].image_path`, img?.image_path)
        else
          data.append(`news_event_images[${index}].image_file`, img);
      });
      deletedimages.forEach((id, index) => {
        data.append(`deleted_news_event_images[${index}]`, id);
      });
      setisErr(false);
      postNE(data)
        .then(({ data }) => {
          setIsLoading(false);
          if (data.success || data.error_code == 0 || data.error_code == 1) {
            navigate("/dashboard/news&Events", {
              state: { page: page },
            });
          } else {
            setisErr(true);
            seterrMsg(data.message);
          }
        })
        .catch((err) => {
          setIsLoading(false);
          setisErr(true);
          seterrMsg(err.message);
          console.log("post news axios err", err);
        });
    }
  };

  const deleteOnclick = () => {
    setModalIsOpen(true);
  };
  const deleteClick = () => {
    setIsLoading(true);
    setisErr(false);
    let obj = {
      id: newsEventObj.id,
    };
    deleteNE(obj)
      .then(({ data }) => {
        setIsLoading(false);
        if (data.error_code === 0) {
          navigate("/dashboard/news&Events", {
            state: { page: page },
          });
        } else {
          setisErr(true);
          console.log("delete news err", data);
          seterrMsg(data.message);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        setisErr(true);
        seterrMsg(err.message);
        console.log("delete news axios err", err);
      });
  };

  const handleImageErr = () => {
    setImageErr(true);
    setEditImage("");
    setProfileImage("");
  };

  const validate = (val) => {
    if (validator.isURL(val)) return true;
    else setIsValidUrl(false);
    return false;
  };

  const handleRemoveDocument = () => {
    setUploadedDoc("");
    setProfileImage("");
    setEditImage(" ");
    setEditDoc("");
    setthumbnailType(false);
    setEditDoc("");
  };

  const getPdfImg = () => {
    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

    if (uploadedDoc) {
      try {
        const fileReader = new FileReader();
        fileReader.onload = async () => {
          const arrayBuffer = fileReader.result;
          const pdfData = new Uint8Array(arrayBuffer);

          // Load the PDF using react-pdf
          const pdf = await pdfjs.getDocument({ data: pdfData }).promise;

          // Load the first page of the PDF
          const page = await pdf.getPage(1);
          // Convert the page to an image
          const viewport = page.getViewport({ scale: 1 });
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");
          canvas.width = viewport.width;
          canvas.height = viewport.height;
          await page.render({ canvasContext: context, viewport }).promise;

          canvas.toBlob((blob) => {

            const file = new File([blob], "first_page.png", {
              type: "image/png",
            });

            // setProfileImage(file);
            setImages(prev => [...prev, file]);
          }, "image/png");
          // setImageData(imageData);
        };
        fileReader.readAsArrayBuffer(uploadedDoc);
      } catch (error) {
        console.error("Error processing the PDF:", error);
      }
    }
  };

  // const thumbnail = useMemo(() => {
  //   if (uploadedDoc && uploadedDoc.type === "application/pdf") {
  //     return (
  //       <Document file={URL.createObjectURL(uploadedDoc)}>
  //         <Page pageNumber={1} />
  //       </Document>
  //     );
  //   } else {
  //     return newsEventObj &&
  //       newsEventObj.image_path !== "" &&
  //       newsEventObj.image_path &&
  //       isEdit ? (
  //       <img
  //         src={baseUrl + newsEventObj.image_path}
  //         height={"100%"}
  //         width={"100%"}
  //         alt="Document Thumbnail"
  //       />
  //     ) : null;
  //   }
  // }, [uploadedDoc]);


  function removeImage(index, image) {
    if (image.image_path) setDeletedImages(prev => [...prev, image.id]);
    let newArr = [...images];
    newArr.splice(index, 1);
    setImages(newArr);
  }

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        className="deleteModal animate__animated animate__zoomIn"
        style={{ display: "flex" }}
      >
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            <div
              className="delClient-cross"
              onClick={(e) => {
                setModalIsOpen(false);
              }}
            >
              <RxCross2 color="white" size={"20"} />
            </div>
            <>
              <h3 style={{ color: "white", marginBottom: "60px" }}>
                Are you sure you want to delete?
              </h3>

              <Gbtn
                text="Delete"
                color="#EE282E"
                radius="6px"
                width="40%"
                func={deleteClick}
              />
            </>
          </>
        )}
      </Modal>
      <div className="mainDashView">
        <div>
          <DashNav svg={icon} DashboardNavText={"News & Events"} />
        </div>
        <div className="dashPanel">
          <div
            style={{
              display: isErr ? "flex" : "none",
              color: "red",
              justifyContent: "center",
              position: "absolute",
              width: "60%",
            }}
          >
            Error! {errMsg}
          </div>

          <div className="ae-formArea">
            {isLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <LoadingSpinner />
              </div>
            ) : (
              <div className="ae-form">
                <div className="ae-formFields">
                  <div className="ae-inputField">
                    <InputField
                      cat="Title"
                      name={"title"}
                      isErr={titleErr}
                      errorMsg="Title is required"
                      value={newsEventObj ? newsEventObj.title : ""}
                      onChange={(e) => {
                        setTitleErr(false);
                        handleChange(e);
                      }}
                      placeholder="Enter title"
                    />
                  </div>
                  <div
                    className="ae-inputField"
                    style={{ position: "relative" }}
                  >
                    <div className="ar-selectText">Catageory</div>
                    <Select
                      options={catOpt}
                      placeholder={"News Catageory"}
                      // defaultValue={selectedCat}
                      value={selectedCat !== "" ? selectedCat : ""}
                      className="ae-select"
                      onChange={(e) => {
                        setCatErr(false);
                        setCatType(e);
                      }}
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          //   backgroundColor: state.isFocused ? "white" : "#F5F6FA",
                          width: "310px",
                          border: `1px solid ${catErr ? "red" : " lightgray"}`,
                          borderColor: catErr ? "red" : "lightgray",
                          //   marginLeft: "4px",
                          marginRight: "0px",
                          borderRadius: "8px",
                          fontSize: "14px",
                          padding: "0px 13px",
                        }),
                      }}
                    />
                    <div
                      className="err-txt"
                      style={{
                        display: catErr ? "flex" : "none",
                        width: "150px",
                        position: "absolute",
                        bottom: "0",
                      }}
                    >
                      Catageory is required
                    </div>
                  </div>
                  {/* <div className="ae-inputField">
                <InputField
                  type="date"
                  value={isEdit ? newsEventObj.posted_date : ""}
                  onChange={handleChange}
                  placeholder="Po Date"
                />
              </div> */}
                </div>
                <div className="ae-formFields" style={{ marginTop: "-12px" }}>
                  <div className="ae-inputField">
                    <InputField
                      name={"short_description"}
                      isErr={shortDescriptionErr}
                      errorMsg="Field is required"
                      value={newsEventObj ? newsEventObj.short_description : ""}
                      onChange={(e) => {
                        setshortDescriptionErr(false);
                        handleChange(e);
                      }}
                      placeholder="Short Description"
                    />
                  </div>
                  <div className="ae-inputField">
                    {/* <InputField
                    name={"detailed_description"}
                    isErr={detDescriptionErr}
                    errorMsg="Field is required"
                    value={
                      newsEventObj ? newsEventObj.detailed_description : ""
                    }
                    onChange={handleChange}
                    placeholder="Detailed Description"
                  /> */}
                    <InputField
                      name={"youtube_link"}
                      isErr={yLinkErr || !isValidUrl}
                      errorMsg={
                        !isValidUrl ? "Not a Valid URL" : "Link is required"
                      }
                      value={newsEventObj ? newsEventObj.youtube_link : ""}
                      onChange={(e) => {
                        setyLinkErr(false);
                        setIsValidUrl(true);
                        handleChange(e);
                      }}
                      placeholder="Youtube Link"
                    />
                  </div>
                </div>
                <div style={{ position: "relative", marginBottom: "14px" }}>
                  <div
                    className="ae-formFields"
                    style={{
                      width: "92%",
                      marginTop: "3em",
                      marginBottom: "0px",
                    }}
                  >
                    <RichTextarea
                      name={"Detailed Description"}
                      isErr={detDescriptionErr}
                      errorMsg="Field is required"
                      value={
                        newsEventObj ? newsEventObj.detailed_description : ""
                      }
                      onChange={(e) => {
                        setdetDescriptionErr(false);
                        setnewsEvents({
                          ...newsEvents,
                          detailed_description: e,
                        });
                      }}
                      placeholder="Detailed Description"
                    />
                  </div>
                  <div
                    className="err-txt"
                    style={{
                      display: detDescriptionErr ? "flex" : "none",
                      position: "absolute",
                      width: "150px",
                    }}
                  >
                    Description is required
                  </div>
                </div>
                <div className="files-inputs-container">
                  <div className="file-input">
                    <div className="if-txt" style={{ marginTop: "40px" }}>
                      Upload PDF
                    </div>
                    <div
                      className="Add_Client_Image_container"
                      style={{ position: "relative" }}
                    >
                      {editDoc || uploadedDoc ? (
                        <>
                          <div
                            onClick={() =>
                              window.open(
                                uploadedDoc
                                  ? URL.createObjectURL(uploadedDoc)
                                  : baseUrl + newsEventObj.document_path,
                                "_blank"
                              )
                            }
                          >
                            <FcDocument size={"100%"} />
                          </div>

                          {editDoc || uploadedDoc ? (
                            <div
                              className="document-cross"
                              onClick={() => handleRemoveDocument()}
                            >
                              <RxCross2 size={15} color="white" />
                            </div>
                          ) : null}
                          <div>
                            <input
                              type="file"
                              className="formuploadimage_input"
                              accept=".pdf, .ppt,.pptx, .doc, .docx"
                              onChange={(e) => {
                                setdocErr(false);
                                onSelectDoc(e.target.files[0]);
                              }}
                              onClick={(event) =>
                                (event.currentTarget.value = null)
                              }
                            />
                          </div>
                        </>
                      ) : (
                        <label className="changeimage-label">
                          <div className="AddimageBtn">
                            <span className="cam_Image_upload">+</span>
                            <div>
                              <input
                                type="file"
                                className="formuploadimage_input"
                                accept=".pdf, .ppt,.pptx, .doc, .docx"
                                onChange={(e) => {
                                  setdocErr(false);
                                  onSelectDoc(e.target.files[0]);
                                }}
                                onClick={(event) =>
                                  (event.currentTarget.value = null)
                                }
                              />
                            </div>
                          </div>
                        </label>
                      )}
                    </div>
                    <div
                      className="err-txt"
                      style={{
                        display: docErr ? "flex" : "none",
                        width: "150px",
                      }}
                    >
                      document is required
                    </div>
                  </div>
                  <div className="file-input">
                    {/* {thumbnailType ? (
                      <div>
                        <div className="if-txt" style={{ marginTop: "40px" }}>
                          Add Image
                        </div>
                        <div className="Add_Client_Image_container">
                          <label className="changeimage-label">
                            {editImage || profileImage ? (
                              <>
                                <img
                                  src={
                                    editImage
                                      ? baseUrl + editImage
                                      : URL.createObjectURL(profileImage)
                                  }
                                  onError={handleImageErr}
                                  alt="cp"
                                  height="120px"
                                  width="120px"
                                  className="add-image-Style"
                                />
                                <div>
                                  <input
                                    type="file"
                                    className="formuploadimage_input"
                                    accept=".png, .jpg, .jpeg"
                                    onChange={(e) =>
                                      onSelectImage(e.target.files[0])
                                    }
                                    onClick={(event) =>
                                      (event.currentTarget.value = null)
                                    }
                                  />
                                </div>
                              </>
                            ) : (
                              <div className="AddimageBtn">
                                <span className="cam_Image_upload">+</span>
                                <div>
                                  <input
                                    type="file"
                                    className="formuploadimage_input"
                                    accept=".png, .jpg, .jpeg"
                                    onChange={(e) =>
                                      onSelectImage(e.target.files[0])
                                    }
                                    onClick={(event) =>
                                      (event.currentTarget.value = null)
                                    }
                                  />
                                </div>
                              </div>
                            )}
                          </label>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div className="if-txt" style={{ marginTop: "40px" }}>
                          Thumbnail
                        </div>
                        <div className="thumbnail_container">{thumbnail}</div>
                      </div>
                    )} */}

                    <div>
                      <div className="if-txt" style={{ marginTop: "40px" }}>
                        Add Image
                      </div>
                      <div className="Add_Client_Image_container">
                        <label className="changeimage-label">

                          <div className="AddimageBtn">
                            <span className="cam_Image_upload">+</span>
                            <div>
                              <input
                                type="file"
                                className="formuploadimage_input"
                                accept=".png, .jpg, .jpeg"
                                multiple
                                onChange={(e) =>
                                  onSelectImage(e.target.files)
                                }
                                onClick={(event) =>
                                  (event.currentTarget.value = null)
                                }
                              />
                            </div>

                          </div>

                        </label>
                      </div>
                    </div>
                  </div>
                  {images?.map((image, index) => (

                    <div className="Add_Client_Image_container news_image">
                      <label className="changeimage-label">
                        <img
                          src={
                            image.image_path
                              ? baseUrl + image.image_path
                              :
                              URL?.createObjectURL(image)
                          }
                          onError={handleImageErr}
                          alt="cp"
                          height="120px"
                          width="120px"
                          className="add-image-Style"
                        />

                      </label>
                      <div
                        className="images_cross"
                        onClick={() => removeImage(index, image)}
                      >
                        <RxCross2 size={15} color="white" />
                      </div>
                    </div>
                  ))
                  }
                </div>
              </div>
            )}

            <div>
              <div className="ev-btnAdd ev-btn">
                <Gbtn
                  text={isEdit ? "Update" : isDelete ? "Delete" : "Add"}
                  func={isDelete ? deleteOnclick : addOnclick}
                  disabled={isLoading}
                  color={isLoading ? "#df2f35c4" : "#DF2F35"}
                  radius="5px"
                  width="160px"
                />
              </div>
              <div className="ev-btnDel ev-btn">
                <Gbtn
                  func={discardOnclick}
                  text={isDelete ? "Back" : "Discard"}
                  color="#0061B1"
                  radius="5px"
                  width="160px"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NEAddEdit;
